import type { RepContact } from "./_types";
import logEvent from "./logEvent";
import type { LoggingEvent } from './logEvent'


/**
 *
 * @param props This object contains
 */

const repContact = ({ state, type, target, id, subject_type }: RepContact) => {
  // UA
  // Handled as a legacy event at the moment

  // Tag Manager
  let layerUpdate: LoggingEvent = { event: "rep_contact"};

  if (type) layerUpdate.contact_type = type;
  if (state) layerUpdate.contact_state = state;
  if (target) layerUpdate.contact_target = target;
  if (id) layerUpdate.result_id = id;
  if (subject_type) layerUpdate.subject_type = subject_type;
  
  logEvent(layerUpdate);
};

export default repContact;
